import { render, staticRenderFns } from "./sortTableCom.vue?vue&type=template&id=d22fc302&"
import script from "./sortTableCom.vue?vue&type=script&lang=js&"
export * from "./sortTableCom.vue?vue&type=script&lang=js&"
import style0 from "./sortTableCom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports